import * as React from 'react';
import { sanitize } from 'dompurify';
export default function extraSettings({ templateSection }) {
  const text = templateSection && templateSection.text ? templateSection.text : 'Extra Setting';

  return <div className="pdf-body-copy-wrap" dangerouslySetInnerHTML={{ __html: sanitize(text) }} />;
}
